<template>
  <div class="modal fade" id="modalSync" role="dialog">
    <div class="modal-dialog">
      <!-- Modal content-->
      <div class="modal-content">
        <div class="modal-header">
          <button type="button" class="close" data-dismiss="modal">&times;</button>
          <h4 class="title-modal">Sincronização.</h4>
        </div>

        <div class="modal-body">
          <div class="double-btn-center">
            <button v-on:click="sendSync('Sincronizando Funcionarios')" class="first">
              <span v-if="!loading.first">Sincronizar Funcionarios</span>
              <div class="loading.first" v-else>
                <div class="spinner-btn">
                  <div class="rect1"></div>
                  <div class="rect2"></div>
                  <div class="rect3"></div>
                  <div class="rect4"></div>
                  <div class="rect5"></div>
                </div>
              </div>
            </button>

            <button v-on:click="sendSync('Forçar Sincronização')" class="second">
              <span v-if="!loading.second">Forçar Sincronização</span>
              <div class="loading.second" v-else>
                <div class="spinner-btn">
                  <div class="rect1"></div>
                  <div class="rect2"></div>
                  <div class="rect3"></div>
                  <div class="rect4"></div>
                  <div class="rect5"></div>
                </div>
              </div>
            </button>

            <button v-on:click="sendSync('Atualizar Infos')" class="third">
              <span v-if="!loading.five">Atualizar Infos</span>
              <div class="loading.five" v-else>
                <div class="spinner-btn">
                  <div class="rect1"></div>
                  <div class="rect2"></div>
                  <div class="rect3"></div>
                  <div class="rect4"></div>
                  <div class="rect5"></div>
                </div>
              </div>
            </button>

            <button v-on:click="sendSync('Logout')" class="four">
              <span v-if="!loading.six">Logout</span>
              <div class="loading.six" v-else>
                <div class="spinner-btn">
                  <div class="rect1"></div>
                  <div class="rect2"></div>
                  <div class="rect3"></div>
                  <div class="rect4"></div>
                  <div class="rect5"></div>
                </div>
              </div>
            </button>
          </div>

          <div class="form-group">
            <label>Data</label>
            <input v-model="dataSearch.date1" type="text" class="form-control" name="code" v-mask="['##-##-####']"
                   placeholder="00/00/00">
          </div>

          <button v-on:click="sendSync('Log de Ponto')" type="submit" class="send-btn-modal">
            <span v-if="!loading.third">Log de Ponto Pendente</span>
            <div class="loading.third" v-else>
              <div class="spinner-btn">
                <div class="rect1"></div>
                <div class="rect2"></div>
                <div class="rect3"></div>
                <div class="rect4"></div>
                <div class="rect5"></div>
              </div>
            </div>
          </button>

          <div class="form-group">
            <label>Data</label>
            <input v-model="dataSearch.date2" type="text" class="form-control" name="code" v-mask="['##-##-####']"
                   placeholder="00/00/00">
          </div>

          <button v-on:click="sendSync('Log de Ações')" type="submit" class="send-btn-modal">
            <span v-if="!loading.four">Log de Ações</span>
            <div class="loading.four" v-else>
              <div class="spinner-btn">
                <div class="rect1"></div>
                <div class="rect2"></div>
                <div class="rect3"></div>
                <div class="rect4"></div>
                <div class="rect5"></div>
              </div>
            </div>
          </button>
        </div>

        <div class="modal-footer">
          <button v-on:click="closeModal()" class="close-btn">Fechar</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  SEND_TAB_NOTIFICATION
} from "../../../urlConfig";
import {
  REQUEST_SERVICE
} from "../../../requestConfig";
import {
  UTIL_SERVICE
} from "../../../requestConfig";
import {
  ALERT_SERVICE
} from "../../../msgAlertService";
import {
  mask
} from 'vue-the-mask'

export default {
  name: "modalSync",
  props: ['dataModal'],
  data() {
    return {
      dataShow: '',
      loading: {
        first: false,
        second: false,
        third: false,
        four: false,
        five: false,
        six: false
      },
      dataSearch: {
        date1: '',
        date2: ''
      },
      loadingChange: false
    }
  },
  directives: {
    mask
  },
  watch: {
    dataModal: function (val) {
      this.dataShow = val;
    }
  },
  methods: {
    closeModal() {
      $('#modalSync').modal('toggle');
    },
    sendSync(value) {
      let url = SEND_TAB_NOTIFICATION;
      url += "?companyId=" + this.dataShow.companyId;
      url += "&deviceId=" + this.dataShow.deviceId;
      url += "&action=" + value;

      if (value === "Sincronizando Funcionarios")
        this.loading.first = true;

      if (value === "Forçar Sincronização")
        this.loading.second = true;

      if (value === "Log de Ponto") {
        this.loading.third = true;

        if (this.dataSearch.date1)
          url += "&date=" + this.dataSearch.date1;
      }

      if (value === "Log de Ações") {
        this.loading.four = true;

        if (this.dataSearch.date2)
          url += "&date=" + this.dataSearch.date2;
      }

      if (value === "Atualizar Infos")
        this.loading.five = true;

      if (value === "Logout")
        this.loading.six = true;

      UTIL_SERVICE.console("DATA SEND:", url);

      REQUEST_SERVICE.get(url).then((response) => {
        UTIL_SERVICE.console("RESULT SEND_TAB_NOTIFICATION:", response);

        this.loading.first = false;
        this.loading.second = false;
        this.loading.third = false;
        this.loading.four = false;
        this.loading.five = false;
        this.loading.six = false;

        $('#modalSync').modal('toggle');

        ALERT_SERVICE.swal("Aviso", response.data, "success");
      }).catch((reason) => {
        $('#modalSync').modal('toggle');

        ALERT_SERVICE.showMsgError(reason.response.data.erros);
      });

    }
  }
}
</script>

<style lang="scss">
#modalSync {
  .error-msg {
    font-size: 12px;
    color: #E74A4E;
    text-align: left;
    display: block;
  }

  .modal-header {
    padding: 15px 15px 0;
    border-bottom: none;
  }

  .double-btn-center {
    display: block;
    margin: 0 auto 50px;

    .first {
      background: #00A651;
      color: #FFF;
      border: none;
      padding: 20px 20px;
      border-radius: 4px !important;
      cursor: pointer;
      font-size: 16px;

      &:hover {
        background-color: #008D45;
      }
    }

    .second {
      background: #0F77AE;
      color: #FFF;
      width: 49%;
      border: none;
      padding: 20px 20px;
      border-radius: 4px !important;
      cursor: pointer;
      font-size: 16px;

      &:hover {
        background-color: #054F91;
      }
    }

    .third {
      background: #C29D0B;
      color: #FFF;
      border: none;
      width: 49%;
      margin-top: 30px;
      padding: 20px 20px;
      border-radius: 4px !important;
      cursor: pointer;
      font-size: 16px;

      &:hover {
        background-color: #AA890A;
      }
    }

    .four {
      background: #E74A4E;
      color: #FFF;
      border: none;
      width: 49%;
      margin-top: 30px;
      padding: 20px 20px;
      border-radius: 4px !important;
      cursor: pointer;
      font-size: 16px;

      &:hover {
        background-color: #E43338;
      }
    }
  }

  .form-group {
    display: inline-block;
    margin-bottom: 20px;

    input {
      height: 37px;
    }
  }

  .send-btn-modal {
    background: #3598DC;
    color: #FFF;
    border: none;
    padding: 0 15px;
    height: 37px;
    border-radius: 4px !important;
    cursor: pointer;
    font-size: 16px;
    display: inline-block;
    margin: 0 auto 0 0;

    &:hover {
      background-color: #054F91;
    }
  }

  .modal-body {
    padding-left: 80px;
    padding-right: 80px;
    margin-top: 20px;
    margin-bottom: 20px;
  }

  .title-modal {
    text-align: center;
    padding-top: 10px;
    font-weight: bold;
    letter-spacing: 1px;
    text-transform: uppercase;
  }

  .modal-footer {
    .close-btn {
      border-radius: 4px !important;
      background-color: #8B8787;
      padding: 7px 35px 7px 35px;
      font-weight: 600;
      text-align: center;
      color: #FFF;
      border: none;
      height: 36px;
    }

    .btn-register {
      border-radius: 4px !important;
      background-color: #3598DC;
      padding: 7px 35px 7px 35px;
      font-weight: 600;
      text-align: center;
      color: #FFF;
      border: none;
      height: 36px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/vue/pages/modals/modalSync.vue